import React from "react";
import QuantityDistribution from "../../../HelperComponents/QuantityDistribution/QuantityDistribution";

export const expandRowsToStickers = (rows) =>
  rows.reduce((acc, row) => {
    for (let i = 0; i < row.unitsCount; i++) {
      acc.push({ id: `${row.id}_${i}`, amount: row.perUnit });
    }
    return acc;
  }, []);

const StickerQuantityDistribution = ({ availableTotal, onChange }) => (
  <div className="accept_product_dialog__stickers">
    <div className="accept_product_dialog__stickers-title">
      Выберите количество стикеров для печати
    </div>
    <QuantityDistribution
      availableTotal={availableTotal}
      defaultAmount={availableTotal}
      availableUnit="шт."
      onChange={onChange}
      labels={{
        perUnit: "Кол-во товара на стикере",
        units: "Кол-во стикеров",
        total: "Всего товаров",
        available: "Доступно товаров",
        plannedUnits: "Будет напечатано стикеров",
        add: "Добавить",
      }}
      renderFooter={({ totalItems, totalUnits }) => {
        const isFull = totalItems === availableTotal;
        const totalsClass = `quantity_distribution__highlight${
          isFull ? "" : " quantity_distribution__highlight--warning"
        }`;
        return (
          <>
            Итого:{" "}
            <span className={totalsClass}>
              {totalItems}/{availableTotal} шт.
            </span>{" "}
            товаров будет напечатано на{" "}
            <span className="quantity_distribution__highlight">
              {totalUnits} стикерах
            </span>
          </>
        );
      }}
    />
  </div>
);

export default StickerQuantityDistribution;
